import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

/**
 * No-Op im Nonce-Build (environment.authStrategy !== 'jwt'): WP übernimmt die
 * Zugriffskontrolle dort bereits über den Shortcode-Betrieb selbst. Nur im
 * JWT-Build (environment.jwt.ts) greift der eigentliche Login-Gate.
 */
export const authGuard: CanActivateFn = () => {
  if (environment.authStrategy !== 'jwt') {
    return true;
  }

  const authService = inject(AuthService);
  const router      = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }
  return router.createUrlTree(['/login']);
};
